import { useEffect, useState } from "react";
import { Loader2, LogIn, PauseCircle, KeyRound, Trash2, ToggleRight, Pencil } from "lucide-react";
import { api } from "@/lib/api";

const ICON = { enter: LogIn, pause: PauseCircle, password: KeyRound, delete: Trash2, feature: ToggleRight, change: Pencil };
const THING = {
  jobs: "a job", clients: "a client", depots: "a depot", schedule: "a roster shift", timesheets: "a timesheet",
  company: "company settings", workers: "the crew", crew: "the crew", invites: "the crew", "time-off": "time off",
  "report-settings": "email settings", payroll: "payroll", products: "a product", lengths: "a length", photos: "a photo",
  coordinator: "timesheets / payroll", "change-requests": "a change request",
};
const VERB = { POST: "Added or ran", PUT: "Updated", PATCH: "Updated", DELETE: "Deleted" };

// "PATCH /api/jobs/123" -> "Updated a job"
const describe = (a) => {
  if (a.action !== "change") return a.detail;
  const [method, path = ""] = a.detail.split(" ");
  const part = path.replace(/^\/api\//, "").split("/")[0];
  return `${VERB[method] || "Changed"} ${THING[part] || part}${a.status >= 400 ? " (failed)" : ""}`;
};
const when = (iso) => new Date(iso).toLocaleString("en-AU", { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" });

export const ActivityPanel = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.ownerAudit().then(setRows).catch(() => setRows([])); }, []);
  if (rows === null) return <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;
  if (rows.length === 0) return <div className="text-center py-16 border border-dashed border-border rounded-2xl text-muted-foreground" data-testid="owner-activity-empty">Nothing yet. Changes you make inside companies show up here.</div>;
  return (
    <div className="bg-card border border-border rounded-xl divide-y divide-border" data-testid="owner-activity">
      {rows.map((a) => {
        const Icon = ICON[a.action] || Pencil;
        return (
          <div key={a.id} className="flex items-start gap-3 px-4 py-3" data-testid={`owner-activity-${a.id}`}>
            <span className="mt-0.5 w-8 h-8 shrink-0 rounded-lg bg-secondary grid place-items-center"><Icon className="w-4 h-4 text-primary" /></span>
            <div className="min-w-0 flex-1">
              <p className="text-sm"><span className="font-semibold">{a.company_name || "—"}</span> · {describe(a)}</p>
              <p className="text-xs text-muted-foreground">{when(a.at)}{a.action === "change" ? <span className="font-mono ml-2">{a.detail}</span> : null}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
